module.exports = __webpack_public_path__ + "media/images/main_search_bg-208940441985769262dc534d44312f22.png";